import store from "@/store";
import {
  CLEAR_ACCOUNT_ISLOADING,
  CLEAR_BUCKET_ISLOADING,
  CLEAR_BUCKET_OPTION_ISLOADING,
  CLEAR_COMPANY_ISLOADING,
  CLEAR_CONTACT_ISLOADING,
  CLEAR_CONTACT_TAG_ISLOADING,
  CLEAR_INTEGRATION_ISLOADING,
  CLEAR_MEETING_ISLOADING,
  CLEAR_NOTE_ISLOADING,
  CLEAR_OPPORTUNITY_CONTACT_ISLOADING,
  CLEAR_OPPORTUNITY_ISLOADING,
  CLEAR_OPPORTUNITY_STAGE_ISLOADING,
  CLEAR_ORGANIZATION_ISLOADING,
  CLEAR_ORGANIZATION_SETTING_ISLOADING,
  CLEAR_TAG_ISLOADING,
  CLEAR_USERS_ISLOADING,
} from "@/store/action-types";

export const resetLoaders = () => {
  store.dispatch(CLEAR_ACCOUNT_ISLOADING);
  store.dispatch(CLEAR_BUCKET_ISLOADING);
  store.dispatch(CLEAR_BUCKET_OPTION_ISLOADING);
  store.dispatch(CLEAR_COMPANY_ISLOADING);
  store.dispatch(CLEAR_CONTACT_ISLOADING);
  store.dispatch(CLEAR_CONTACT_TAG_ISLOADING);
  store.dispatch(CLEAR_INTEGRATION_ISLOADING);
  store.dispatch(CLEAR_MEETING_ISLOADING);
  store.dispatch(CLEAR_NOTE_ISLOADING);
  store.dispatch(CLEAR_OPPORTUNITY_ISLOADING);
  store.dispatch(CLEAR_OPPORTUNITY_CONTACT_ISLOADING);
  store.dispatch(CLEAR_OPPORTUNITY_STAGE_ISLOADING);
  store.dispatch(CLEAR_ORGANIZATION_ISLOADING);
  store.dispatch(CLEAR_ORGANIZATION_SETTING_ISLOADING);
  store.dispatch(CLEAR_TAG_ISLOADING);
  store.dispatch(CLEAR_USERS_ISLOADING);
};
